/*
  Дома портфеля и счета выбранного дома - обе таблицы с серверной пагинацией
  (21.10.2026, требование владельца: «пагинация должна быть серверной, а не на фронте»).

  Хуки, а не состояние внутри вкладки: правило разделения из скилла `frontend` -
  знание про сервер живёт в хуке, компонент получает всё пропсами и сам ничего не
  грузит.

  Счета грузятся ПО ВЫБОРУ дома, а не вместе со списком. Так дешевле (счета
  считает движок триажа), и так честнее: список домов открывают, чтобы увидеть
  портфель целиком, а не чтобы сразу читать фамилии жильцов. Сервер считает требования
  только для домов и счетов открытой страницы, поэтому листание не стоит прогона всего
  портфеля.
*/

import { useCallback, useState } from 'react'

import { api } from '../api/client.js'
import usePagedList from './usePagedList.js'

export function useHouses() {
  const [selected, setSelected] = useState(null)
  const load = useCallback((window) => api.houses(window), [])
  const { rows, error, bar } = usePagedList(load)

  return {
    houses: rows,
    error,
    bar,
    selected,
    select: (address) => setSelected((current) => (current === address ? null : address)),
  }
}

/*
  Счета дома. Окно листания принадлежит выбранному дому: компонент счетов
  пересоздаётся при выборе другого дома (`key`), и страница начинается с первой.
*/
export function useHouseAccounts(address) {
  const load = useCallback((window) => api.houseAccounts(address, window), [address])
  return usePagedList(load)
}
